import { render, staticRenderFns } from "./Telesalud.vue?vue&type=template&id=3a8620dc&scoped=true"
import script from "./Telesalud.vue?vue&type=script&lang=ts"
export * from "./Telesalud.vue?vue&type=script&lang=ts"
import style0 from "./Telesalud.vue?vue&type=style&index=0&id=3a8620dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8620dc",
  null
  
)

export default component.exports